import { createEvent, createStore } from 'effector'

import { closeVault } from '@/models/vault/vault.ts'
import { debounce } from '@/utils/helpers.ts'

export const setMediaSort = createEvent<string>('set media sort')
export const $mediaSort = createStore('desc', { name: 'vault media sort' }).on(
  setMediaSort,
  (_, value) => value,
)

export type MediaSortField = 'recent' | 'most-liked' | 'highest-tips'
export const setMediaSortField = createEvent<MediaSortField>(
  'set media sort field',
)
export const $mediaSortField = createStore<MediaSortField>('recent', {
  name: 'vault media sort field',
}).on(setMediaSortField, (_, value) => value)

export const setMediaQueryParam = createEvent<string>('set media query param')
export const setMediaQuery = debounce(setMediaQueryParam, 500)
export const $mediaQueryParam = createStore('', {
  name: 'vault media query param',
})
  .on(setMediaQueryParam, (_, value) => value)
  .reset(closeVault)
